import { render, staticRenderFns } from "./MainActionModal.vue?vue&type=template&id=118aa296&lang=pug&"
import script from "./MainActionModal.vue?vue&type=script&lang=ts&"
export * from "./MainActionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports